/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetFlagHealthcareFacilityDto
 */
export interface SetFlagHealthcareFacilityDto {
    /**
     * Set this facility as main
     * @type {boolean}
     * @memberof SetFlagHealthcareFacilityDto
     */
    main?: boolean;
    /**
     * Set this facility as online
     * @type {boolean}
     * @memberof SetFlagHealthcareFacilityDto
     */
    online?: boolean;
}

/**
 * Check if a given object implements the SetFlagHealthcareFacilityDto interface.
 */
export function instanceOfSetFlagHealthcareFacilityDto(value: object): value is SetFlagHealthcareFacilityDto {
    return true;
}

export function SetFlagHealthcareFacilityDtoFromJSON(json: any): SetFlagHealthcareFacilityDto {
    return SetFlagHealthcareFacilityDtoFromJSONTyped(json, false);
}

export function SetFlagHealthcareFacilityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetFlagHealthcareFacilityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'main': json['main'] == null ? undefined : json['main'],
        'online': json['online'] == null ? undefined : json['online'],
    };
}

export function SetFlagHealthcareFacilityDtoToJSON(value?: SetFlagHealthcareFacilityDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'main': value['main'],
        'online': value['online'],
    };
}

